import { MAX_DATE_RANGE_DAYS, DATE_VALIDATION_ERRORS } from '@core/utils';

/**
 * Get minimum allowed start datetime (90 days ago from now in UTC)
 */
export const getMinStartDateTime = (): string => {
  const ninetyDaysAgo = new Date();

  ninetyDaysAgo.setUTCDate(ninetyDaysAgo.getUTCDate() - MAX_DATE_RANGE_DAYS);

  return ninetyDaysAgo.toISOString().slice(0, 16);
};

/**
 * Get maximum allowed end datetime (now in UTC)
 */
export const getMaxEndDateTime = (): string => new Date().toISOString().slice(0, 16);

/**
 * Validate date range for content search (all dates treated as UTC)
 * - End datetime cannot be in the future
 * - Start datetime cannot be earlier than 90 days ago
 * - Date range cannot exceed 90 days
 * - End datetime cannot be before start datetime
 */
export const validateDateRange = (start: string, end: string): string => {
  if (!start || !end) return '';

  // Treat datetime-local inputs as UTC by appending 'Z'
  const startDate = new Date(`${start}Z`);
  const endDate = new Date(`${end}Z`);

  const minStart = new Date(`${getMinStartDateTime()}Z`);

  // Check if end datetime is in the future
  if (endDate > new Date()) {
    return DATE_VALIDATION_ERRORS.END_DATE_FUTURE;
  }

  // Check if start datetime is earlier than 90 days ago
  if (startDate < minStart) {
    return DATE_VALIDATION_ERRORS.START_DATE_TOO_OLD;
  }

  // Check if end datetime is before start datetime
  if (endDate < startDate) {
    return DATE_VALIDATION_ERRORS.END_BEFORE_START;
  }

  return '';
};
